import React, { forwardRef, useImperativeHandle, useRef } from 'react';

// Native scrolling preserves the wrapper API without legacy React DOM access.
const ScrollBar = forwardRef(({
  direction = 'ltr', children, style, className, autoHeight = false,
  autoHeightMin = 0, autoHeightMax = 200, autoHide, autoHideTimeout,
  autoHideDuration, renderView, onScrollFrame, ...rest
}, ref) => {
  const element = useRef(null);
  useImperativeHandle(ref, () => ({
    get view() { return element.current; },
    scrollTop(value) { element.current.scrollTop = value; },
    scrollLeft(value) { element.current.scrollLeft = value; },
    scrollToTop() { element.current.scrollTop = 0; },
    scrollToBottom() { element.current.scrollTop = element.current.scrollHeight; },
    getScrollTop() { return element.current.scrollTop; },
    getScrollHeight() { return element.current.scrollHeight; },
  }), []);
  return <div {...rest} ref={element} dir={direction} className={className}
    style={{ overflow: 'auto', height: autoHeight ? 'auto' : '100%', minHeight: autoHeight ? autoHeightMin : undefined, maxHeight: autoHeight ? autoHeightMax : undefined, ...style }}
    onScroll={(event) => {
      rest.onScroll?.(event);
      if (onScrollFrame) {
        const node = event.currentTarget;
        onScrollFrame({ scrollTop: node.scrollTop, scrollLeft: node.scrollLeft, scrollHeight: node.scrollHeight, clientHeight: node.clientHeight });
      }
    }}>{children}</div>;
});

export default ScrollBar;
